var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOut = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.8 3c.3 0 .5.2.5.5s-.2.5-.5.5h-8c-.8 0-1.5.7-1.5 1.5v13c0 .8.7 1.5 1.5 1.5h8c.3 0 .5.2.5.5s-.2.5-.5.5h-8c-1.4 0-2.5-1.1-2.5-2.5v-13C2.3 4.1 3.4 3 4.8 3zm2.3 2.9c.2-.2.5-.2.7 0l5.7 5.7c.1.1.1.2.1.4s-.1.3-.1.4l-5.7 5.7c-.1.1-.2.1-.4.1s-.3 0-.4-.1c-.2-.2-.2-.5 0-.7l4.9-4.8H7.8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H20l-4.8-4.8c-.3-.3-.3-.7-.1-.9"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOut);
export default ForwardRef;